import React from 'react';
import { Link } from 'react-router-dom';
import Layout from './components/Layout';
import SEO from './components/SEO';

const HomePage: React.FC = () => {
  return (
    <Layout isHomePage={true}>
      <SEO 
        title="noprblm."
        description="noprblm."
        keywords="noprblm"
        canonicalUrl="/"
      />
      <section className="hero">
        <div className="statement">
          <Link to="/archive" className="logo-link">
            <img 
              src="/FAVI/noprblm_folder.png" 
              alt="noprblm" 
              className="hero-logo" 
            />
          </Link>
        </div>
      </section>
      
      {/* Content section removed */}
    </Layout>
  );
};

export default HomePage;